import { Button } from '@bedrock/components';
import { CellDescriptions, EllipsisTooltip } from '@mpc/components'
import React from 'react'

/**
 * 达人
 */
const ProfileOfTheExpertCell = (props) => {
  const { record, index, mainPlatformOptions } = props;

  return (
    <div>
      <CellDescriptions
        maxDisplayCount={3}
        column={1}
        items={[
          {
            label: '主平台',
            children:
              <EllipsisTooltip
                text={mainPlatformOptions?.find(v => v.value === record.main_platform)?.name || record.main_platform || '--'}
                clamp={1}
              />
          },
          {
            label: '主平台发布账号',
            children: <EllipsisTooltip
              text={record.main_platform_account || '--'}
              clamp={1}
            />
          },
          {
            label: '主平台链接',
            children: record.main_platform_link ? <Button type="link" size="small" style={{ color: '#1C80EB' }} onClick={() => window.open(record.main_platform_link)}>
              <EllipsisTooltip clamp={1} text={record.main_platform_link} />
            </Button> : '--',
          },
        ]}
      />
    </div>
  )
}

export default ProfileOfTheExpertCell
